import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';

import apiMiddleware from './api/middleware.js';
import reducers from './ducks/index.js';


export default function configureStore({ history, preloadedState } = {}) {

    const middleWares = [
        thunkMiddleware,
        apiMiddleware,
    ];

    if (history) {
        middleWares.push(routerMiddleware(history));
    }

    // TODO: disable devTool in production
    const composeEnhancers = process.env.NODE_TARGET
        ? compose
        : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


    const store = createStore(
        reducers,
        preloadedState,
        composeEnhancers(applyMiddleware(...middleWares)),
    );

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('./ducks', () => {
            const nextRootReducer = require('./ducks').default; // eslint-disable-line global-require
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}
